import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  constructor(
    private userService: UserService,
    private router: Router,
    private zone: NgZone,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    this.trackEvent('home_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid && !u.banned) {
          this.zone.run(async () => {
            // await this.router.navigateByUrl('/dashboard');
            await this.router.navigate(['/dashboard/']);
          });
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  trackEvent(name: string): void {
    this.analyticsService.event(name);
  }
}
